var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGrp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "exit_01",
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6V1.33333H1.33333V10.6667H6V12H1.33333ZM8.66667 9.33333L7.75 8.36667L9.45 6.66667H4V5.33333H9.45L7.75 3.63333L8.66667 2.66667L12 6L8.66667 9.33333Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_01",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21",
    stroke: "#1C1C1C",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user_02",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_686)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#D4F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18C19.3137 18 22 15.3137 22 12C22 8.68629 19.3137 6 16 6C12.6863 6 10 8.68629 10 12C10 15.3137 12.6863 18 16 18Z",
    fill: "#003554"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 30.5,
    rx: 11,
    ry: 10.5,
    fill: "#036596"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "clock_01",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6V12L16 14",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close_01",
    viewBox: "0 0 32 33",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 8.5L8 24.5",
    stroke: "#212121",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5L24 24.5",
    stroke: "#212121",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close_02",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4L4 12",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4L12 12",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close_03",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4L4 12",
    stroke: "#9E9E9E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4L12 12",
    stroke: "#9E9E9E",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "upAngleBrackets_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6L8 10L12 6",
    stroke: "#white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "upAngleBrackets_02",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "downAngleBrackets_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6L8 10L12 6",
    stroke: "#1C1C1C",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "downAngleBrackets_02",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 15L12 9L6 15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rightAngleBrackets_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12L10 8L6 4",
    stroke: "#1C1C1C",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "leftAngleBrackets_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12L6 8L10 4",
    stroke: "#1C1C1C",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rightAngleBrackets_02",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12L10 8L6 4",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "rightAngleBrackets_03",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18L15 12L9 6",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.66669H3.33333C2.59695 2.66669 2 3.26364 2 4.00002V13.3334C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3334V4.00002C14 3.26364 13.403 2.66669 12.6667 2.66669Z",
    stroke: "current",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 1.33331V3.99998",
    stroke: "current",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 1.33331V3.99998",
    stroke: "current",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66669H14",
    stroke: "current",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "refresh_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 2.6665V6.6665H4.66675",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 13.3335V9.3335H11.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6601 5.99989C13.322 5.04441 12.7473 4.19016 11.9898 3.51683C11.2322 2.84351 10.3164 2.37306 9.32789 2.14939C8.33934 1.92572 7.31025 1.95612 6.33662 2.23774C5.363 2.51936 4.47658 3.04303 3.76008 3.75989L0.666748 6.66655M15.3334 9.33322L12.2401 12.2399C11.5236 12.9567 10.6372 13.4804 9.66354 13.762C8.68992 14.0437 7.66082 14.0741 6.67227 13.8504C5.68373 13.6267 4.76795 13.1563 4.01039 12.4829C3.25284 11.8096 2.67819 10.9554 2.34008 9.99989",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "userIco_01",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DFEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 19.9998C23.6821 19.9998 26.6668 17.0151 26.6668 13.3332C26.6668 9.65127 23.6821 6.6665 20.0002 6.6665C16.3183 6.6665 13.3335 9.65127 13.3335 13.3332C13.3335 17.0151 16.3183 19.9998 20.0002 19.9998Z",
    fill: "#002665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89655 28.8665C9.99821 24.2132 14.6199 21.6665 19.4049 21.6665H20.5949C25.3799 21.6665 30.0015 24.2115 31.1032 28.8665C31.3165 29.7682 31.4865 30.7115 31.5815 31.6698C31.6732 32.5865 30.9199 33.3332 29.9999 33.3332H9.99988C9.07988 33.3332 8.32655 32.5848 8.41821 31.6698C8.51321 30.7115 8.68321 29.7682 8.89655 28.8665Z",
    fill: "#0C59DA"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toast_info",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6818 1.33337 7.99992 1.33337C4.31802 1.33337 1.33325 4.31814 1.33325 8.00004C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667V8",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.33337H8.00667",
    stroke: "#FFFFFF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toast_success",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 7.88674V8.50007C14.666 9.93769 14.2005 11.3365 13.3397 12.488C12.4789 13.6394 11.269 14.4817 9.8904 14.8893C8.51178 15.297 7.03834 15.248 5.68981 14.7498C4.34128 14.2516 3.18993 13.3308 2.40747 12.1248C1.62501 10.9188 1.25336 9.49212 1.34795 8.05762C1.44254 6.62312 1.9983 5.25762 2.93235 4.16479C3.8664 3.07195 5.12869 2.31033 6.53096 1.9935C7.93322 1.67668 9.40034 1.82163 10.7135 2.40674",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.16675L8 9.84008L6 7.84008",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toast_warning",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86001 3.07323L1.21335 12.4999C1.09693 12.7015 1.03533 12.9301 1.03467 13.1629C1.03402 13.3957 1.09434 13.6246 1.20963 13.8269C1.32492 14.0292 1.49116 14.1977 1.69182 14.3158C1.89247 14.4339 2.12055 14.4973 2.35335 14.4999H13.6467C13.8795 14.4973 14.1076 14.4339 14.3082 14.3158C14.5089 14.1977 14.6751 14.0292 14.7904 13.8269C14.9057 13.6246 14.966 13.3957 14.9654 13.1629C14.9647 12.9301 14.9031 12.7015 14.7867 12.4999L9.14001 3.07323C9.02117 2.8773 8.85383 2.71531 8.65414 2.60288C8.45446 2.49046 8.22917 2.4314 8.00001 2.4314C7.77086 2.4314 7.54557 2.49046 7.34588 2.60288C7.1462 2.71531 6.97886 2.8773 6.86001 3.07323Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V9.16667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8333H8.00667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "toast_error",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 15.1666C11.6821 15.1666 14.6668 12.1818 14.6668 8.49992C14.6668 4.81802 11.6821 1.83325 8.00016 1.83325C4.31826 1.83325 1.3335 4.81802 1.3335 8.49992C1.3335 12.1818 4.31826 15.1666 8.00016 15.1666Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5L6 10.5",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L10 10.5",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "input_id",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5C7.5 8.981 9.519 11 12 11C14.481 11 16.5 8.981 16.5 6.5C16.5 4.019 14.481 2 12 2C9.519 2 7.5 4.019 7.5 6.5ZM20 21H21V20C21 16.141 17.859 13 14 13H10C6.14 13 3 16.141 3 20V21H20Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "input_pw",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H4C3.73478 22 3.48043 21.8946 3.29289 21.7071C3.10536 21.5196 3 21.2652 3 21V9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H6V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V8ZM16 8V7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7V8H16ZM11 14V16H13V14H11ZM7 14V16H9V14H7ZM15 14V16H17V14H15Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "dash_home",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1335 24C0.691668 24 0.333496 23.6418 0.333496 23.2V8.4C0.333496 8.14819 0.452051 7.91108 0.653496 7.76L10.5202 0.36C10.8046 0.146667 11.1957 0.146667 11.4802 0.36L21.3468 7.76C21.5483 7.91108 21.6668 8.14819 21.6668 8.4V23.2C21.6668 23.6418 21.3087 24 20.8668 24H14.4668C14.025 24 13.6668 23.6418 13.6668 23.2V15.4667C13.6668 15.0248 13.3087 14.6667 12.8668 14.6667H9.1335C8.69167 14.6667 8.3335 15.0248 8.3335 15.4667V23.2C8.3335 23.6418 7.97532 24 7.5335 24H1.1335Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit_01",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.8335H14",
    stroke: "#212121",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2.83316C11.2652 2.56794 11.6249 2.41895 12 2.41895C12.1857 2.41895 12.3696 2.45553 12.5412 2.5266C12.7128 2.59767 12.8687 2.70184 13 2.83316C13.1313 2.96448 13.2355 3.12038 13.3066 3.29196C13.3776 3.46354 13.4142 3.64744 13.4142 3.83316C13.4142 4.01888 13.3776 4.20277 13.3066 4.37436C13.2355 4.54594 13.1313 4.70184 13 4.83316L4.66667 13.1665L2 13.8332L2.66667 11.1665L11 2.83316Z",
    stroke: "#212121",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.3335V12.6668",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8H12.6673",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus_01",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8H12.6673",
    stroke: "#212121",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrp);
export default __webpack_public_path__ + "static/media/Icon_grp.9c73479f430bb2cd279451950bcc4ec3.svg";
export { ForwardRef as ReactComponent };